import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Home from './pages/Home';
import AboutUniversity from './pages/AboutUniversity';
import Admissions from './pages/Admissions';
import OnlineCourses from './pages/OnlineCourses';
import StudentLife from './pages/StudentLife';
import Contact from './pages/Contact';
import Footer from './components/Footer';
import NotFound from './components/NotFound';

import './App.css';

function App() {
  return (
    <Router>
      <div className="app">
        <Navbar />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutUniversity />} />
            <Route path="/admissions" element={<Admissions />} />
            <Route path="/online-courses" element={<OnlineCourses />} />
            <Route path="/student-life" element={<StudentLife />} />
            <Route path="/contact" element={<Contact />} />     


            {/* Catch-all route for 404 Not Found */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </main>
        <Footer />
      </div>
    </Router>
  );
}

export default App;